import { motion } from 'framer-motion';

function Balloons() {
  const colors = ['#FF69B4', '#00ccff', '#ffcc00', '#99ff99', '#ff6666'];

  return (
    <>
      {[...Array(10)].map((_, i) => {
        const randomX = Math.floor(Math.random() * 100); // 0% to 100%
        const randomDelay = Math.random() * 3;
        const color = colors[i % colors.length];

        return (
          <motion.div
            key={i}
            className="balloon"
            style={{ backgroundColor: color, left: `${randomX}%` }}
            initial={{ y: '100vh', opacity: 0.6 }}
            animate={{ y: '-20vh', opacity: 0 }}
            transition={{
              duration: 8 + i * 0.5,
              repeat: Infinity,
              delay: randomDelay,
              ease: 'easeOut'
            }}
          />
        );
      })}
    </>
  );
}

export default Balloons;
